const InvestmentsChallenge2Dataset = {
        items: {
            "item-1": { id: "item-1", content: "Typically offers steady, fixed interest payments and is considered " +
                "lower risk than stocks.", 
                    answer: "column-3"}, 
            "item-2": { id: "item-2", content: "Low-risk savings product with fixed returns; money is locked for a specific time period.", 
                    answer: "column-5"}, 
            "item-3": { id: "item-3", content: "Represents ownership in a company; high risk but high potential return.", 
                    answer: "column-4"}, 
            "item-4": { id: "item-4", content: "Provides instant diversification across a broad market with a single investment.",
                    answer: "column-2"},
        },
        columns: {
            "column-1": { id: "column-1", title: "Investment Characteristics", 
                itemIds: ['item-1', 'item-2', 'item-3', "item-4"] },
            "column-2": { id: "column-2", title: "Index Funds", itemIds: [] },
            "column-3": { id: "column-3", title: "Bonds", itemIds: [] },
            "column-4": { id: "column-4", title: "Stocks", itemIds: [] },
            "column-5": { id: "column-5", title: "Certificate of Deposit (CDs)", itemIds: [] },
                  
        },
        columnOrder: ["column-1", "column-2", "column-3", "column-4", "column-5"]
    }

export default InvestmentsChallenge2Dataset